import { render, staticRenderFns } from "./AggregateSoul.vue?vue&type=template&id=35960926&scoped=true&"
import script from "./AggregateSoul.vue?vue&type=script&lang=js&"
export * from "./AggregateSoul.vue?vue&type=script&lang=js&"
import style0 from "./AggregateSoul.vue?vue&type=style&index=0&id=35960926&scoped=true&lang=css&"
import style1 from "./AggregateSoul.vue?vue&type=style&index=1&id=35960926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35960926",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBreadcrumbs,VBtn,VCard,VDataTable,VDatePicker,VFlex,VIcon,VLayout,VMenu,VSpacer,VTextField,VToolbar,VToolbarTitle,VTooltip})
